;(function() {
  'use strict'

  var dependencies = []

  angular.module('core.qr', dependencies)

  // --------------------
})()
